export default "__VITE_ASSET__DqKEFkSs__"